<template>
  <v-card class="elevation-4">
    <v-card-title class="justify-start py-2 card-modaltitle">
      <div class="pl-4">
        <h3 class="primary--text">
          Asignación no permitida, utilice un vehículo alternativo
        </h3>
      </div>
      <v-btn depressed text color="primary" class="cont" @click="$emit('close')">
        <v-icon class="mr-1">fa-solid fa-xmark</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <div class="alert-body">
        <p class="mb-4"><b>Motivo:</b> Vehículo con documentos vencidos o no válidos.</p>

        <div class="list">
          <p v-for="(doc, idx) in orderedDocs" :key="idx" class="list-item">
            {{ idx + 1 }}. {{ translateDescription(doc.description) }}: {{ formatExpirationDate(doc.expirationDate) }}
          </p>
        </div>

        <p class="mt-4">
          El vehículo {{ licensePlate }} no cumple con los requisitos necesarios para esta asignación.
        </p>
      </div>

      <v-row class="justify-end mt-4 pr-2">
        <v-btn color="primary" depressed @click="$emit('close')">Aceptar</v-btn>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'VehicleDocumentsAlertModal',
  props: {
    licensePlate: { type: String, default: '' },
    documents: { type: Array, default: () => [] }
  },
  computed: {
    orderedDocs() {
      const getOrder = (desc = '') => {
        const d = String(desc);
        if (/SOAT/i.test(d)) return 1;
        if (/TechnicalReview/i.test(d)) return 2;
        if (/RcePolicy/i.test(d)) return 3;
        if (/ThermoCertificate/i.test(d)) return 4;
        if (/PreventivePest|Pest/i.test(d)) return 5;
        if (/HealthRegistry|Carnic|Lactic/i.test(d)) return 6;
        return 99;
      };
      return this.documents.slice().sort((a, b) => getOrder(a?.description) - getOrder(b?.description));
    }
  },
  methods: {
    translateDescription(desc) {
      const key = this.normalizeDocKey(desc);
      const map = {
        SOAT: 'components.views.modals.vehicle_documents_alert.certificates.soat',
        TECHNICAL_REVIEW: 'components.views.modals.vehicle_documents_alert.certificates.technical_review',
        RCE_POLICY: 'components.views.modals.vehicle_documents_alert.certificates.rce_policy',
        THERMO_CERTIFICATE: 'components.views.modals.vehicle_documents_alert.certificates.thermo_certificate',
        PREVENTIVE_PEST: 'components.views.modals.vehicle_documents_alert.certificates.preventive_pest',
        HEALTH_REGISTRY_CARNIC: 'components.views.modals.vehicle_documents_alert.certificates.health_registry_carnic',
        HEALTH_REGISTRY_LACTIC: 'components.views.modals.vehicle_documents_alert.certificates.health_registry_lactic'
      };
      const path = map[key];
      if (path && this.$te(path)) {
        return this.$t(path);
      }
      const fallback = this.fallbackLabel(key);
      return fallback || String(desc);
    },
    normalizeDocKey(desc) {
      const d = String(desc || '').toUpperCase();
      if (/SOAT/.test(d)) return 'SOAT';
      if (/TECHNICALREVIEW|TECNICOMECA/.test(d)) return 'TECHNICAL_REVIEW';
      if (/RCEPOLICY|RCE/.test(d)) return 'RCE_POLICY';
      if (/THERMOCERTIFICATE|TERMO/.test(d)) return 'THERMO_CERTIFICATE';
      if (/PREVENTIVEPEST|PEST/.test(d)) return 'PREVENTIVE_PEST';
      if (/HEALTHREGISTRY.*CARNIC|CARNIC/.test(d)) return 'HEALTH_REGISTRY_CARNIC';
      if (/HEALTHREGISTRY.*LACTIC|LACTIC/.test(d)) return 'HEALTH_REGISTRY_LACTIC';
      return d;
    },
    fallbackLabel(key) {
      const locale = this.$i18n?.locale || 'es';
      const es = {
        SOAT: 'SOAT',
        TECHNICAL_REVIEW: 'Tecnicomecánica',
        RCE_POLICY: 'Póliza RCE',
        THERMO_CERTIFICATE: 'Certificación de Termo',
        PREVENTIVE_PEST: 'Certificado Gestión Integrada y Preventiva de Plagas',
        HEALTH_REGISTRY_CARNIC: 'Registro Sanitario Cárnico',
        HEALTH_REGISTRY_LACTIC: 'Registro Sanitario Láctico'
      };
      const en = {
        SOAT: 'SOAT',
        TECHNICAL_REVIEW: 'Technical Review',
        RCE_POLICY: 'RCE Policy',
        THERMO_CERTIFICATE: 'Thermo Certification',
        PREVENTIVE_PEST: 'Integrated and Preventive Pest Management Certificate',
        HEALTH_REGISTRY_CARNIC: 'Meat Health Registry',
        HEALTH_REGISTRY_LACTIC: 'Dairy Health Registry'
      };
      const dict = locale === 'en' ? en : es;
      return dict[key];
    },
    formatExpirationDate(expirationDate) {
      if (!expirationDate) return 'Fecha no disponible';
      const date = new Date(expirationDate);
      if (isNaN(date.getTime())) return 'Fecha no disponible';
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }
  }
};
</script>

<style scoped>
.card-modaltitle {
  border-bottom: 1px solid #ccc;
}

.alert-body {
  white-space: pre-line;
}

.list {
  margin-left: 8px;
}

.list-item {
  margin: 6px 0;
  padding-left: 8px;
}

.cont {
  position: absolute;
  right: 10px;
}
</style>
